import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import './ColumnSection.css';

function ColumnSection() {
  const { columnist } = useParams();
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState(null);
  const [user, setUser] = useState(null);
  const [searchKeyword, setSearchKeyword] = useState('');
  const [searchType, setSearchType] = useState('all');
  const [searchInfo, setSearchInfo] = useState(null);

  // 기본 칼럼니스트를 kimhr로 설정
  const currentColumnist = columnist || 'kimhr';

  const columnists = {
    kimhr: { id: 'kimhr', name: '김혜란', title: '김혜란의 그림읽기' },
    fieldpath: { id: 'fieldpath', name: '들길', title: '들길의 그림일기' },
    india: { id: 'india', name: '김현혁', title: '김현혁의 인도의 길' },
    theo: { id: 'theo', name: '정용섭', title: '정용섭 목사의 신학단상' }
  };

  useEffect(() => {
    // 사용자 정보 확인
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        setUser(payload);
      } catch (e) {
        console.error('Token parsing error:', e);
      }
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const apiBase = process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001';
        let url;
        if (searchKeyword.trim()) {
          url = `${apiBase}/api/board/${currentColumnist}/search?keyword=${encodeURIComponent(searchKeyword)}&searchType=${searchType}&page=${page}&limit=20`;
        } else {
          url = `${apiBase}/api/board/${currentColumnist}?page=${page}&limit=20`;
        }

        const response = await fetch(url);
        const data = await response.json();

        // 응답 구조 확인
        const postsArray = data.posts || [];
        const paginationData = data.pagination;

        const formattedPosts = postsArray.map(item => {
          const dateStr = item.regdate || '';
          const year = dateStr.substring(0, 4);
          const month = dateStr.substring(4, 6);
          const day = dateStr.substring(6, 8);
          return {
            id: item.document_srl,
            title: item.title,
            author: item.nick_name || item.user_name,
            date: `${year}.${month}.${day}`,
            views: item.readed_count || 0,
            comments: item.comment_count || 0
          };
        });

        setPosts(formattedPosts);
        setPagination(paginationData);
        setSearchInfo(data.searchInfo || null);
      } catch (error) {
        console.error('Board fetch error:', error);
        setPosts([]);
        setPagination(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentColumnist, page, searchKeyword, searchType]);

  const handleTabClick = (columnistId) => {
    setPage(1);
    navigate(`/columns/${columnistId}`);
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
    window.scrollTo(0, 0);
  };

  const canWrite = () => {
    return user && (user.is_admin === 'Y' || user.nick_name === '정용섭');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
  };

  const handleResetSearch = () => {
    setSearchKeyword('');
    setSearchType('all');
    setSearchInfo(null);
    setPage(1);
  };

  return (
    <div className="column-section">
      <div className="column-header">
        <h1>칼럼방</h1>
      </div>

      {/* Sub Navigation */}
      <div className="sub-navigation">
        {Object.values(columnists).map(col => (
          <button
            key={col.id}
            className={`nav-tab ${currentColumnist === col.id ? 'active' : ''}`}
            onClick={() => handleTabClick(col.id)}
          >
            {col.name}
          </button>
        ))}
      </div>

      {/* Board Content */}
      <div className="board-content">
        <div className="board-header">
          <h2>{columnists[currentColumnist].title}</h2>
          <span className="post-count">총 {pagination ? pagination.total : posts.length}개의 글</span>
        </div>

        {/* 검색 폼 */}
        <form onSubmit={handleSearch} style={{ marginBottom: '20px', padding: '15px', background: '#f9f9f9', borderRadius: '4px' }}>
          <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
            <select
              value={searchType}
              onChange={(e) => setSearchType(e.target.value)}
              style={{ padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px' }}
            >
              <option value="all">전체</option>
              <option value="title">제목</option>
              <option value="content">내용</option>
            </select>
            <input
              type="text"
              value={searchKeyword}
              onChange={(e) => setSearchKeyword(e.target.value)}
              placeholder="검색어를 입력하세요"
              style={{ flex: 1, padding: '8px 12px', border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px' }}
            />
            <button
              type="submit"
              style={{ padding: '8px 20px', background: '#748320', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}
            >
              검색
            </button>
            {searchKeyword.trim() && (
              <button
                type="button"
                onClick={handleResetSearch}
                style={{ padding: '8px 20px', background: '#666', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: '600' }}
              >
                초기화
              </button>
            )}
          </div>
        </form>

        {/* 검색 결과 정보 */}
        {searchInfo && (
          <div style={{ marginBottom: '15px', padding: '10px', background: '#e8f5e9', borderRadius: '4px', fontSize: '14px', color: '#2e7d32' }}>
            '<strong>{searchInfo.keyword}</strong>' 검색 결과: 총 <strong>{searchInfo.resultsCount}</strong>개의 게시글이 검색되었습니다.
          </div>
        )}

        {loading ? (
          <div className="loading">로딩 중...</div>
        ) : (
          <>
            <table className="post-table">
              <thead>
                <tr>
                  <th className="col-num">번호</th>
                  <th className="col-title">제목</th>
                  <th className="col-author">작성자</th>
                  <th className="col-views">조회</th>
                  <th className="col-date">날짜</th>
                </tr>
              </thead>
              <tbody>
                {posts.length > 0 ? (
                  posts.map((post, idx) => {
                    const postNumber = pagination
                      ? pagination.total - ((page - 1) * pagination.limit) - idx
                      : posts.length - idx;
                    return (
                      <tr key={post.id}>
                        <td className="col-num">{postNumber}</td>
                        <td className="col-title">
                          <Link to={`/columns/${currentColumnist}/${post.id}`}>
                            {post.title}
                          </Link>
                          {post.comments > 0 && (
                            <span style={{ color: '#748320', marginLeft: '5px' }}>
                              [{post.comments}]
                            </span>
                          )}
                        </td>
                        <td className="col-author">{post.author}</td>
                        <td className="col-views">{post.views || 0}</td>
                        <td className="col-date">{post.date}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="5" className="no-data">게시글이 없습니다.</td>
                  </tr>
                )}
              </tbody>
            </table>

            {pagination && pagination.totalPages > 1 && (
              <Pagination
                current={pagination.current}
                totalPages={pagination.totalPages}
                onPageChange={handlePageChange}
              />
            )}

            {canWrite() && (
              <div style={{ textAlign: 'right', marginTop: '20px' }}>
                <Link
                  to={`/write/${currentColumnist}`}
                  style={{
                    display: 'inline-block',
                    background: '#748320',
                    color: 'white',
                    textDecoration: 'none',
                    padding: '10px 20px',
                    borderRadius: '4px',
                    fontSize: '14px',
                    fontWeight: '600'
                  }}
                >
                  글쓰기
                </Link>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default ColumnSection;
